import React, { useEffect } from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='privacy-policy-container'>
      <div className="privacy-policy-title">Privacy Policy</div>
      
      {/* COMING SOON NOTICE - Remove this section once business is live and location is finalized */}
      <div className="privacy-policy-notice">
        <strong>Important Notice:</strong> DJ's Dog Bar is currently in a "coming soon" phase. 
        We are not yet open for business and do not have a finalized location. This privacy policy 
        is subject to change prior to our official opening. By using our website and services, you 
        acknowledge that you have read and understood this privacy policy.
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">1. Introduction</h2>
        <p className="privacy-content">
          DJ's Dog Bar ("we," "our," or "us") is committed to protecting your privacy. This Privacy 
          Policy explains how we collect, use, disclose, and safeguard your information when you 
          visit our website, create an account, or use our services. Please read this policy 
          carefully to understand our practices regarding your personal information.
        </p>
</div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">2. Information We Collect</h2>
        
        <h3 className="privacy-subsection-title">2.1 Account Information</h3>
        <p className="privacy-content">
          When you create an account, we collect:
        </p>
        <ul className="privacy-list">
          <li>Name</li>
          <li>Email address</li>
          <li>Password (stored securely in encrypted form)</li>
          <li>Phone number (optional)</li>
          <li>Primary location preference</li>
        </ul>

        <h3 className="privacy-subsection-title">2.2 Dog Information</h3>
        <p className="privacy-content">
          To register your dog(s) with our services, we collect:
        </p>
        <ul className="privacy-list">
          <li>Dog's name</li>
          <li>Breed</li>
          <li>Date of birth</li>
          <li>Sex</li>
        </ul>
        <p className="privacy-content">
          <em>Note: While all dogs must be spayed or neutered to use our facilities, we do not 
          collect or store spay/neuter status information in our system.</em>
        </p>

        <h3 className="privacy-subsection-title">2.3 Vaccination Records</h3>
        <p className="privacy-content">
          We collect and store vaccination information for each registered dog, including:
        </p>
        <ul className="privacy-list">
          <li>Vaccination type (Rabies, DAP, DHPP, DHLPP, Da2PP, etc.)</li>
          <li>Vaccination dates</li>
        </ul>

        <h3 className="privacy-subsection-title">2.4 Waiver Information</h3>
        <p className="privacy-content">
          When you sign our waivers, we collect:
        </p>
        <ul className="privacy-list">
          <li>Date and time of signature</li>
          <li>Confirmation of agreement to Park Rules</li>
          <li>Confirmation of agreement to Family Guidelines (if applicable)</li>
        </ul>

        <h3 className="privacy-subsection-title">2.5 Payment Information</h3>
        <p className="privacy-content">
          When you make purchases or set up memberships, we collect payment information through 
          our secure payment processor (Stripe). We do not store your full credit card details on 
          our servers. Stripe handles all payment processing and storage of sensitive payment 
          information in accordance with PCI DSS standards.
        </p>

        <h3 className="privacy-subsection-title">2.6 Usage Information</h3>
        <p className="privacy-content">
          We collect the following information related to your account usage:
        </p>
        <ul className="privacy-list">
          <li>Membership status and visit history</li>
          <li>Purchase history</li>
        </ul>

        <h3 className="privacy-subsection-title">2.7 Newsletter and Communications</h3>
        <p className="privacy-content">
          If you subscribe to our newsletter or marketing communications, we collect your email 
          address and track your subscription preferences.
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">3. How We Use Your Information</h2>
        <p className="privacy-content">
          We use the information we collect for the following purposes:
        </p>
        <ul className="privacy-list">
          <li><strong>Account Management:</strong> To create and manage your account, authenticate 
              your identity, and provide access to our services</li>
          <li><strong>Dog Registration:</strong> To register your dogs, verify vaccination status, 
              and ensure compliance with our Park Rules</li>
          <li><strong>Waiver Management:</strong> To track waiver signatures and ensure all visitors 
              have agreed to our rules and liability terms</li>
          <li><strong>Service Delivery:</strong> To process payments, manage memberships, track 
              visits, and provide customer support</li>
          <li><strong>Safety and Compliance:</strong> To verify vaccination requirements, enforce 
              Park Rules, and maintain a safe environment for all guests and dogs</li>
          <li><strong>Communications:</strong> To send you important updates about our services, 
              changes to policies, newsletters (if subscribed), and respond to your inquiries</li>
          <li><strong>Legal Compliance:</strong> To comply with applicable laws, regulations, and 
              legal processes</li>
          <li><strong>Business Operations:</strong> To analyze usage patterns, improve our services, 
              and conduct business analytics</li>
        </ul>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">4. How We Share Your Information</h2>
        <p className="privacy-content">
          <strong>We do not sell your personal information, and we do not share your data except 
          when absolutely necessary to provide our services or when legally required.</strong> We 
          maintain a strict policy of minimal data sharing and only share information in the 
          following limited circumstances:
        </p>
        <ul className="privacy-list">
          <li><strong>Payment Processing (Stripe):</strong> We share only the minimum payment 
              information necessary with Stripe to process your payments. This includes payment 
              card information, which is handled entirely by Stripe in accordance with PCI DSS 
              standards. We do not have access to your full card details.</li>
          <li><strong>Legal Requirements:</strong> We will only disclose information if we are 
              legally required to do so by law, court order, or government regulation. We will 
              not voluntarily share your information unless legally compelled.</li>
          <li><strong>With Your Explicit Written Consent:</strong> We will only share your 
              information with third parties if you provide explicit, written consent for a 
              specific purpose. We will not share your information based on implied consent.</li>
        </ul>
        <p className="privacy-content">
          <strong>We do not share your vaccination records, waiver information, dog information, 
          or any other sensitive personal data with third parties except as strictly necessary for 
          payment processing (Stripe) or when legally required by law.</strong> We do not use your 
          data for marketing purposes with third parties, and we do not participate in data 
          sharing or selling arrangements.
        </p>
        <p className="privacy-content">
          <strong>To be perfectly clear: we will never sell your data. We make money from our 
          customers, not from selling our customers' information to third parties. Your privacy 
          and trust are worth far more to us than any data sale could ever be.</strong>
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">5. Data Security</h2>
        <p className="privacy-content">
          We implement comprehensive technical and organizational security measures to protect your 
          personal information against unauthorized access, alteration, disclosure, or destruction. 
          These measures include:
        </p>
        <ul className="privacy-list">
          <li><strong>Encryption in Transit:</strong> All communications between your device and 
              our servers use industry-standard encryption protocols to protect data during transmission.</li>
          <li><strong>Password Security:</strong> Passwords are hashed using industry-standard 
              cryptographic hashing algorithms with unique salts. Passwords are never stored in 
              plain text and cannot be recovered if forgotten (password reset is required).</li>
          <li><strong>Payment Processing:</strong> All payment processing is handled exclusively 
              through PCI DSS compliant payment processors. We do not store, process, or have access 
              to your full credit card numbers, CVV codes, or expiration dates.</li>
          <li><strong>Access Controls:</strong> All sensitive operations require secure authentication. 
              Users can only access and modify their own account data.</li>
          <li><strong>Data Protection:</strong> Sensitive information (passwords, authentication tokens, 
              payment identifiers) is encrypted or hashed before storage in our database.</li>
          <li><strong>Security Measures:</strong> We implement multiple layers of security protection 
              including input validation, error message sanitization, and monitoring to prevent common 
              security vulnerabilities. Authentication tokens expire after a set period for additional 
              security.</li>
        </ul>
        <p className="privacy-content">
          However, no method of transmission over the internet or electronic storage is 100% secure. 
          While we implement industry-standard security practices and strive to protect your information, 
          we cannot guarantee absolute security.
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">6. Your Rights and Choices</h2>
        <p className="privacy-content">
          You have the following rights regarding your personal information:
        </p>
        <ul className="privacy-list">
          <li><strong>Access & Correction:</strong> You can access and update your account information, 
              dog profiles, and vaccination records through your account settings.</li>
          <li><strong>Deletion:</strong> You can request deletion of your account and associated 
              data by contacting us. Certain information may be retained as required by law (such as 
              waiver signatures for liability purposes).</li>
          <li><strong>Opt-Out:</strong> You can unsubscribe from marketing emails at any time through 
              your account preferences or by using the unsubscribe link in our emails.</li>
          <li><strong>Data Requests:</strong> You can request a copy of your personal data by 
              contacting us through our website or using the contact information provided.</li>
        </ul>
        <p className="privacy-content">
          To exercise these rights, please contact us through our website or using the contact 
          information provided.
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">7. Data Retention</h2>
        <p className="privacy-content">
          We retain your personal information for as long as necessary to provide our services and 
          fulfill the purposes outlined in this policy, unless a longer retention period is required 
          or permitted by law. Specifically:
        </p>
        <ul className="privacy-list">
          <li>Account information is retained while your account is active and deleted when you 
              request account deletion</li>
          <li>Vaccination records are retained while your dogs are registered with us</li>
          <li>Payment transaction records are retained as required by financial regulations and may 
              remain in our payment processor's systems</li>
        </ul>
        <p className="privacy-content">
          When you delete your account, we will delete your personal information and associated 
          data (including dogs). Payment transaction records may be retained for 
          legal and financial compliance purposes.
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">8. Children's Privacy</h2>
        <p className="privacy-content">
          DJ's Dog Bar is a 21+ establishment. We do not knowingly collect personal information 
          from individuals under 21 years of age. If you are a parent or guardian and believe your 
          child has provided us with personal information, please contact us immediately. If we 
          discover that we have collected information from someone under 21, we will delete that 
          information promptly.
        </p>
        <p className="privacy-content">
          Note: While we welcome families with children under 21 in certain circumstances (as 
          outlined in our Family Guidelines), all account creation and data collection is done by 
          the adult parent or guardian.
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">9. Cookies and Tracking Technologies</h2>
        <p className="privacy-content">
          We use cookies to maintain your session and protect against security threats. Specifically:
        </p>
        <ul className="privacy-list">
          <li><strong>Session cookies</strong> are used to maintain your login session when using 
              OAuth authentication (Google or Facebook login)</li>
          <li><strong>Security cookies</strong> are used to protect against cross-site request 
              forgery (CSRF) attacks</li>
        </ul>
        <p className="privacy-content">
          These cookies are essential for the security and functionality of our website. You can 
          control cookies through your browser settings, but disabling cookies may limit your 
          ability to use certain features of our website.
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">10. Third-Party Links</h2>
        <p className="privacy-content">
          Our website may contain links to third-party websites or services. We are not responsible 
          for the privacy practices of these third parties. We encourage you to read the privacy 
          policies of any third-party websites you visit.
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">11. Changes to This Privacy Policy</h2>
        <p className="privacy-content">
          We may update this Privacy Policy from time to time, especially as we prepare for our 
          official opening. We will notify you of material changes by posting the updated 
          policy on our website and, where appropriate, sending you an email notification. The 
          "Last Updated" date at the bottom of this policy indicates when it was last revised. 
          Your continued use of our services after changes become effective constitutes your 
          acceptance of the updated policy.
        </p>
      </div>

      <div className="privacy-section">
        <h2 className="privacy-section-title">12. Contact Us</h2>
        <p className="privacy-content">
          If you have questions, concerns, or requests regarding this Privacy Policy or our data 
          practices, please contact us through our website or at the contact information provided 
          on our website.
        </p>
      </div>

      <div className="privacy-last-updated">
        <p><em>Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</em></p>
        <p><em>Note: This privacy policy is subject to change as we prepare for our official opening.</em></p>
      </div>
    </div>
  );
}

export default PrivacyPolicy;

